var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNextCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 34.5,
    width: 34,
    height: 34,
    rx: 10,
    transform: "rotate(-90 1 34.5)",
    stroke: "#CED3DE",
    strokeMiterlimit: 0,
    strokeLinejoin: "bevel"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0191 17.5C22.0191 17.7301 21.9227 17.9602 21.7301 18.1356L15.6667 23.6561C15.281 24.0072 14.6557 24.0072 14.2701 23.6561C13.8846 23.305 13.8846 22.7358 14.2701 22.3846L19.6353 17.5L14.2703 12.6155C13.8848 12.2643 13.8848 11.6951 14.2703 11.3441C14.6559 10.9928 15.2812 10.9928 15.6669 11.3441L21.7303 16.8644C21.9229 17.04 22.0191 17.27 22.0191 17.5L22.0191 17.5Z",
    fill: "#222B45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextCalendar);
export default __webpack_public_path__ + "static/media/next-calendar.0ea4845531db2ef10478149f675467f0.svg";
export { ForwardRef as ReactComponent };